const en = {
  nav: {
    product: 'Product',
    resources: 'Resources',
    company: 'Company',
    menus: {
      product: [
        { to: '/features', title: 'Features', desc: 'Security, access control, and admin tools' },
        { to: '/pricing', title: 'Pricing', desc: 'Plans for teams of every size' },
        { to: '/docs', title: 'Getting started', desc: 'Install, connect, and manage in minutes' },
        { to: '/updates', title: 'What\'s new', desc: 'Product updates and improvements' },
      ],
      resources: [
        { to: '/docs', title: 'Documentation', desc: 'Guides for admins and end users' },
        { to: '/help', title: 'Help Center', desc: 'Answers to common questions' },
        { to: '/status', title: 'System status', desc: 'Live availability of core services' },
        { to: '/updates', title: 'Changelog', desc: 'Release notes and platform changes' },
      ],
      company: [
        { to: '/about', title: 'About ArcVPN', desc: 'Who we are and how we work' },
        { to: '/careers', title: 'Careers', desc: 'Open roles and how we hire' },
        { to: '/contact', title: 'Contact', desc: 'Sales, support, and partnerships' },
        { to: '/help', title: 'Support', desc: 'Get help from our team' },
      ],
    },
  },
  footer: {
    blurb: 'Corporate remote access with clear controls, calm operations, and support that answers.',
    columns: [
      {
        title: 'Product',
        links: [
          { to: '/features', label: 'Features' },
          { to: '/pricing', label: 'Pricing' },
          { to: '/docs', label: 'Documentation' },
          { to: '/updates', label: 'Updates' },
        ],
      },
      {
        title: 'Company',
        links: [
          { to: '/about', label: 'About' },
          { to: '/careers', label: 'Careers' },
          { to: '/contact', label: 'Contact' },
          { to: '/status', label: 'Status' },
        ],
      },
      {
        title: 'Support',
        links: [
          { to: '/help', label: 'Help Center' },
          { to: '/docs', label: 'Guides' },
          { to: '/contact', label: 'Talk to sales' },
          { to: '/login', label: 'Customer login' },
        ],
      },
    ],
    rights: '© 2026 ArcVPN. All rights reserved.',
  },
  landing: {
    title: 'Quiet, reliable access for every team.',
    description: 'Give people a secure path to company resources — with central control and less day-to-day friction.',
    cta: 'Start free trial',
    featuresTitle: 'What teams actually use',
    featuresSubtitle: 'A focused set of capabilities for remote work, branches, and admin oversight.',
    features: [
      { title: 'Strong encryption', description: 'Traffic stays private end to end, with sensible defaults for company networks.' },
      { title: 'Fast enough to forget', description: 'Connections stay responsive so people can work without thinking about the tunnel.' },
      { title: 'Central control', description: 'Invite users, manage devices, and see connection activity from one place.' },
    ],
    platformsTitle: 'Works where your people work',
    platformsSubtitle: 'Desktop and mobile coverage for mixed environments.',
    networkTitle: 'A network shaped around your company',
    networkSubtitle: 'Connect offices, field teams, and remote desks through one managed surface.',
    useTitle: 'Built for real company shapes',
    useSubtitle: 'From small remote teams to multi-site operations.',
    useCases: [
      { title: 'Remote staff', description: 'Give home and hybrid workers a clean path into internal tools.' },
      { title: 'Branches & sites', description: 'Link factories, stores, and offices without building a maze of one-off tunnels.' },
      { title: 'Mobile access', description: 'Keep phones and tablets on the same trusted access model.' },
    ],
    ctaTitle: 'Ready when your team is',
    ctaDescription: 'Start with a short trial, invite your first users, and grow from there.',
    ctaButton: 'Create account',
  },
};

const tr = {
  nav: {
    product: 'Ürün',
    resources: 'Kaynaklar',
    company: 'Şirket',
    menus: {
      product: [
        { to: '/features', title: 'Özellikler', desc: 'Güvenlik, erişim kontrolü ve yönetim araçları' },
        { to: '/pricing', title: 'Fiyatlandırma', desc: 'Her ölçekteki ekipler için planlar' },
        { to: '/docs', title: 'Hızlı başlangıç', desc: 'Kurulum, bağlantı ve yönetim' },
        { to: '/updates', title: 'Yenilikler', desc: 'Ürün güncellemeleri ve iyileştirmeler' },
      ],
      resources: [
        { to: '/docs', title: 'Dokümantasyon', desc: 'Yönetici ve kullanıcı rehberleri' },
        { to: '/help', title: 'Yardım Merkezi', desc: 'Sık sorulan soruların yanıtları' },
        { to: '/status', title: 'Sistem durumu', desc: 'Temel servislerin anlık durumu' },
        { to: '/updates', title: 'Sürüm notları', desc: 'Yayınlar ve platform değişiklikleri' },
      ],
      company: [
        { to: '/about', title: 'ArcVPN hakkında', desc: 'Kim olduğumuz ve nasıl çalıştığımız' },
        { to: '/careers', title: 'Kariyer', desc: 'Açık roller ve işe alım süreci' },
        { to: '/contact', title: 'İletişim', desc: 'Satış, destek ve iş ortaklığı' },
        { to: '/help', title: 'Destek', desc: 'Ekibimizden yardım alın' },
      ],
    },
  },
  footer: {
    blurb: 'Kurumsal uzaktan erişim: net kontroller, sakin operasyon ve yanıt veren destek.',
    columns: [
      {
        title: 'Ürün',
        links: [
          { to: '/features', label: 'Özellikler' },
          { to: '/pricing', label: 'Fiyatlandırma' },
          { to: '/docs', label: 'Dokümantasyon' },
          { to: '/updates', label: 'Güncellemeler' },
        ],
      },
      {
        title: 'Şirket',
        links: [
          { to: '/about', label: 'Hakkımızda' },
          { to: '/careers', label: 'Kariyer' },
          { to: '/contact', label: 'İletişim' },
          { to: '/status', label: 'Durum' },
        ],
      },
      {
        title: 'Destek',
        links: [
          { to: '/help', label: 'Yardım Merkezi' },
          { to: '/docs', label: 'Rehberler' },
          { to: '/contact', label: 'Satış ile konuş' },
          { to: '/login', label: 'Müşteri girişi' },
        ],
      },
    ],
    rights: '© 2026 ArcVPN. Tüm hakları saklıdır.',
  },
  landing: {
    title: 'Ekipler için sakin ve güvenilir erişim.',
    description: 'Şirket kaynaklarına güvenli bir yol açın — merkezi kontrolle, günlük sürtünmeyi azaltarak.',
    cta: 'Ücretsiz dene',
    featuresTitle: 'Ekiplerin gerçekten kullandığı şeyler',
    featuresSubtitle: 'Uzaktan çalışma, şubeler ve yönetim için odaklı yetenekler.',
    features: [
      { title: 'Güçlü şifreleme', description: 'Trafik uçtan uca korunur; kurumsal ağlar için dengeli varsayılanlar.' },
      { title: 'Unutulacak kadar akıcı', description: 'Bağlantı hızlı kalır; insanlar tüneli düşünmeden çalışır.' },
      { title: 'Merkezi kontrol', description: 'Kullanıcı davet edin, cihazları yönetin, bağlantı aktivitesini tek yerden görün.' },
    ],
    platformsTitle: 'İnsanlarınızın çalıştığı yerlerde',
    platformsSubtitle: 'Karma ortamlarda masaüstü ve mobil kapsama.',
    networkTitle: 'Şirketinize göre şekillenen ağ',
    networkSubtitle: 'Ofisleri, saha ekiplerini ve uzaktan masaları tek yönetim yüzeyinde birleştirin.',
    useTitle: 'Gerçek şirket yapıları için',
    useSubtitle: 'Küçük uzaktan ekiplerden çok lokasyonlu operasyonlara.',
    useCases: [
      { title: 'Uzaktan çalışanlar', description: 'Ev ve hibrit ekiplere iç araçlara temiz bir yol verin.' },
      { title: 'Şube ve sahalar', description: 'Fabrika, mağaza ve ofisleri tek seferlik tünel karmaşası olmadan bağlayın.' },
      { title: 'Mobil erişim', description: 'Telefon ve tabletleri aynı güvenilir erişim modelinde tutun.' },
    ],
    ctaTitle: 'Ekibiniz hazır olduğunda',
    ctaDescription: 'Kısa bir deneme ile başlayın, ilk kullanıcıları davet edin, oradan büyütün.',
    ctaButton: 'Hesap oluştur',
  },
};

export function getMarketing(lang = 'en') {
  if (lang?.startsWith('tr')) return tr;
  return en;
}
